import { Link } from 'react-router-dom';
import { Alert, Row } from 'antd';
import { useProductsQuery } from '../apollo/api';
import Bookcase from '../ui-components/Bookcase';
import LibraryItem from '../ui-components/LibraryItem';

export default function Library() {
  const { loading, error, data } = useProductsQuery();

  return (
    <>
      <div className="Library-header">
        <h1>Libreria</h1>
        {data && data.productInstances.some((p) => p.product!.id.startsWith('PSX')) && (
          <Link to="/resources">Risorse</Link>
        )}
      </div>

      {loading && <p>Caricamento...</p>}

      {error && <Alert message={error.message} type="error" showIcon />}

      {data && (
        <Bookcase>
          <Row justify="space-around">
            {data.productInstances.reduce((elements: JSX.Element[], p) => {
              const product = p.product!;
              return product.id.startsWith('PSX')
                ? elements
                : [...elements, <LibraryItem product={product} key={product.id} />];
            }, [])}
          </Row>
        </Bookcase>
      )}
    </>
  );
}
